 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLFM1 from '@/components/xhtml/fm1'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLFM2 from '@/components/xhtml/fm2'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLINTRODUCTION from '@/components/xhtml/introduction'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLEDITORS_NOTE from '@/components/xhtml/editors_note'
 import XHTMLBRIEF_INTRODUCTION from '@/components/xhtml/brief_introduction'
 import XHTMLCHAPTER1 from '@/components/xhtml/chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/chapter5'
 import XHTMLCHAPTER6 from '@/components/xhtml/chapter6'
 import XHTMLBACKMATTER from '@/components/xhtml/backmatter'
 import XHTMLABOUTTHEAUTHOR from '@/components/xhtml/abouttheauthor'
 import XHTMLBACKCOVER from '@/components/xhtml/backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/introduction",
 			"name" : "xhtml/introduction",
 			"component" : XHTMLINTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js